import '../../../styles/scss/banner/banner.scss'
import {FC} from 'react'
import {Image} from "antd";
import {WordList} from "../../../shared/types/api";
import Constants from "../../../const/Constants";
import {Player} from "@lottiefiles/react-lottie-player";


interface TreeWateringProps {
    selectedWordList?: WordList
    currentImage: string,
    watering: boolean,
}

const TreeWatering: FC<TreeWateringProps> = ({
                                                 selectedWordList,
                                                 currentImage,
                                                 watering
                                                     }) => {

    return (
        <>
            {selectedWordList?.tree?.status !== Constants.TREE_STATUSES[0] &&
                <div style={{
                    position: 'relative',
                    width: 200,
                    height: 200,
                    margin: '16px auto',
                }}>
                    <Image
                        src={currentImage}
                        preview={false}
                        width={200}
                        height={200}
                        style={{
                            objectFit: 'contain',
                            borderRadius: 12,
                            display: 'block',
                            position: 'relative',
                            zIndex: 1,
                        }}
                    />

                    {watering && (
                        <Player
                            src="../images/trees/water.json"
                            autoplay
                            loop={false}
                            keepLastFrame
                            speed={1}
                            style={{
                                position: 'absolute',
                                bottom: -20,
                                left: -40,
                                width: 160,
                                height: 160,
                                pointerEvents: 'none',
                                zIndex: 2,
                            }}
                        />
                    )}
                </div>
            }
        </>
    )
}

export default TreeWatering
